export const DESTAQUE_TABS = [
  { key: "BANNER", label: "Banners" },
  { key: "LOOKBOOK", label: "Lookbooks" },
  { key: "VIDEO", label: "Vídeos" },
  { key: "MATERIAL", label: "Materiais" },
  { key: "CAMPANHA", label: "Campanhas" },
];

export const TIPO_FILTERS = [
  { value: "BANNER", label: "Banner" },
  { value: "VIDEO", label: "Vídeo" },
  { value: "MATERIAL_PDF", label: "PDF" },
];

export const SORT_OPTIONS = [
  { value: "recentes", label: "Mais recentes" },
  { value: "downloads", label: "Mais baixados" },
];

export const INITIAL_FILTERS = {
  tipos: [],
  categorias: [],
  campanhas: [],
  apenasAtivos: true,
  ordenacao: "recentes",
};

export const HERO_CAMPAIGNS = [
  {
    id: 1,
    titulo: "Inverno 24",
    subtitulo: "Conforto que abraça",
    imagem: "https://picsum.photos/seed/karsten-hero1/1200/400",
    campanhaId: 1,
  },
  {
    id: 2,
    titulo: "Coleção Verão 2026",
    subtitulo: "Leveza e estilo para sua loja",
    imagem: "https://picsum.photos/seed/karsten-hero2/1200/400",
    campanhaId: 3,
  },
  {
    id: 3,
    titulo: "Dia das Mães",
    subtitulo: "Campanha especial de vendas",
    imagem: "https://picsum.photos/seed/karsten-hero3/1200/400",
    campanhaId: 2,
  },
];

export const MOCK_MARKETING_CONTENTS = [
  {
    id: 1,
    titulo: "Coleção Inverno 2026",
    descricao: "Campanha principal da coleção de inverno",
    tipo: "CAMPANHA",
    categoria: "Coleção",
    campanha: "Coleção Inverno 2026",
    tags: ["inverno", "coleção", "2026"],
    status: "PUBLICADO",
    dataInicio: "2026-03-01",
    dataFim: "2026-08-31",
    dataAtualizacao: "2026-05-20",
    downloads: 342,
    thumbnail: "https://picsum.photos/seed/karsten1/400/260",
    isNovo: true,
  },
  {
    id: 2,
    titulo: "Banner Dia das Mães",
    descricao: "Banner promocional para vitrine",
    tipo: "BANNER",
    categoria: "Datas comemorativas",
    campanha: "Dia das Mães",
    tags: ["mães", "promoção", "banner"],
    status: "PUBLICADO",
    dataInicio: "2026-05-01",
    dataFim: "2026-12-31",
    dataAtualizacao: "2026-04-28",
    downloads: 128,
    thumbnail: "https://picsum.photos/seed/karsten2/400/260",
    isNovo: true,
  },
  {
    id: 13,
    titulo: "Banner Coleção Inverno",
    descricao: "Banner para vitrine da coleção inverno",
    tipo: "BANNER",
    categoria: "Coleção",
    campanha: "Coleção Inverno 2026",
    tags: ["inverno", "banner", "vitrine"],
    status: "PUBLICADO",
    dataInicio: "2026-03-01",
    dataFim: "2026-12-31",
    dataAtualizacao: "2026-05-10",
    downloads: 256,
    thumbnail: "https://picsum.photos/seed/karsten13/400/260",
    isNovo: false,
  },
  {
    id: 3,
    titulo: "Lookbook Verão 2026",
    descricao: "Catálogo visual da coleção verão",
    tipo: "LOOKBOOK",
    categoria: "Coleção",
    campanha: "Coleção Verão 2026",
    tags: ["verão", "lookbook", "coleção"],
    status: "PUBLICADO",
    dataInicio: "2026-01-15",
    dataFim: "2026-12-31",
    dataAtualizacao: "2026-05-18",
    downloads: 567,
    thumbnail: "https://picsum.photos/seed/karsten3/400/260",
    isNovo: false,
  },
  {
    id: 4,
    titulo: "Karsten Ser Casa",
    descricao: "Vídeo de lançamento da coleção Karsten Ser Casa",
    tipo: "VIDEO",
    categoria: "Lançamento",
    campanha: "Karsten Ser Casa",
    tags: ["ser casa", "vídeo"],
    status: "PUBLICADO",
    dataInicio: "2026-06-01",
    dataFim: "2026-09-30",
    dataAtualizacao: "2026-05-25",
    downloads: 89,
    thumbnail: "https://picsum.photos/seed/karsten4/400/260",
    videoUrl: "https://www.youtube.com/embed/N9d5mpRmCZE?si=zH4BJrNwqkXxYkDE",
    isNovo: true,
  },
  {
    id: 5,
    titulo: "Manual de Merchandising",
    descricao: "PDF com diretrizes de exposição",
    tipo: "MATERIAL_PDF",
    categoria: "VM / Merchandising",
    campanha: "Kit VM Loja Conceito",
    tags: ["vm", "merchandising", "pdf"],
    status: "PUBLICADO",
    dataInicio: "2026-01-01",
    dataFim: "2026-12-31",
    dataAtualizacao: "2026-05-10",
    downloads: 891,
    thumbnail: "https://picsum.photos/seed/karsten5/400/260",
    tamanho: "2.4 MB",
    isNovo: false,
  },
  {
    id: 7,
    titulo: "Lussure Trussardi",
    descricao: "Vídeo de lançamento da coleção Lussure Trussardi",
    tipo: "VIDEO",
    categoria: "Lançamento",
    campanha: "Lussure Trussardi",
    tags: ["lussure", "trussardi", "vídeo"],
    status: "PUBLICADO",
    dataInicio: "2026-06-01",
    dataFim: "2026-12-31",
    dataAtualizacao: "2026-05-25",
    downloads: 89,
    thumbnail: "https://picsum.photos/seed/karsten7/400/260",
    videoUrl: "https://www.youtube.com/embed/qGuBmhFSB60?si=xlBFkszBK6wo4BxF",
    isNovo: true,
  },
  {
    id: 10,
    titulo: "Catálogo Banho 2024",
    descricao: "Material PDF com produtos de banho",
    tipo: "MATERIAL_PDF",
    categoria: "Campanha Comercial",
    campanha: "Catálogo Banho",
    tags: ["banho", "catálogo", "pdf"],
    status: "PUBLICADO",
    dataInicio: "2026-01-01",
    dataFim: "2026-12-31",
    dataAtualizacao: "2026-05-22",
    downloads: 445,
    thumbnail: "https://picsum.photos/seed/karsten10/400/260",
    tamanho: "2.4 MB",
    isNovo: true,
  },
  {
    id: 11,
    titulo: "Tabela de Medidas",
    descricao: "Referência de medidas de produtos",
    tipo: "MATERIAL_PDF",
    categoria: "Campanha Comercial",
    campanha: "Referências Técnicas",
    tags: ["medidas", "tabela", "pdf"],
    status: "PUBLICADO",
    dataInicio: "2026-01-01",
    dataFim: "2026-12-31",
    dataAtualizacao: "2026-05-15",
    downloads: 312,
    tamanho: "1.1 MB",
    isNovo: false,
  },
  {
    id: 12,
    titulo: "Guia de Cores",
    descricao: "Paleta oficial de cores da marca",
    tipo: "MATERIAL_PDF",
    categoria: "Institucional",
    campanha: "Institucional Karsten",
    tags: ["cores", "guia", "pdf"],
    status: "PUBLICADO",
    dataInicio: "2026-01-01",
    dataFim: "2026-12-31",
    dataAtualizacao: "2026-05-12",
    downloads: 278,
    tamanho: "3.6 MB",
    isNovo: false,
  },
];
